import membersRepository, {
  Member,
  MemberRole,
  AddMembersPayload,
  Invite,
  InviteMembersResponse,
} from "../repositories/members.repository";

interface InviteRow {
  email: string;
  role: MemberRole; // lo que viene desde el drawer (ADMIN | READ_ONLY)
}

class MembersService {

  async getStaffMembers(): Promise<Member[]> {
    return await membersRepository.getStaffMembers();
  }

  async getStaffInvited(): Promise<Invite[]> {
    return await membersRepository.getStaffInvited();
  }


  async inviteMembers(rows: InviteRow[]): Promise<InviteMembersResponse> {
    const payload: AddMembersPayload = {
      members: rows.map((r) => ({
        email: r.email,
        staffRole: r.role, // backend espera staffRole
      })),
    };
    return await membersRepository.addMembers(payload);
  }

  async resendStaffInvite(email: string): Promise<void> {
    if (!email) {
      throw new Error("Email is required to resend invite");
    }
    return await membersRepository.resendStaffInvite(email);
  }


  async deleteInvited(email: string): Promise<void> {
    if (!email) {
      throw new Error("Email is required to delete invite");
    }
    return await membersRepository.deleteInvitedByEmail(email);
  }

  async signupFromInvite(
    dto: {
      accessKey: string;
      email: string;
      firstName: string;
      lastName: string;
      country: string;
      phoneNumber: string;
      username: string;
      password: string;
    },
    imageFile: File | null
  ): Promise<unknown> {
    return await membersRepository.signupFromInvite(dto, imageFile);
  }
}

export default new MembersService();
